export const RAD = {
  navRadiology: "nav-radiology",
  page: "radiology-page",
  title: "radiology-title",
  banner: "radiology-reference-banner",
  table: "radiology-table",
  loading: "radiology-loading",
  emptyState: "radiology-empty",
  errorState: "radiology-error",
  row: "radiology-row",
};
